import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../Particle";
import Home2 from "./Home2";
import Type from "./Type";
import "./home.css";
import finalImage from './final1.png';


function Home() {
  const handleScrollToBottom = () => {
    window.scrollTo({
      top: document.documentElement.scrollHeight,
      behavior: 'smooth',
    });
  };

  return (
    <section>
      <Container fluid className="home-section" id="home">
        <Particle />
        <Container className="home-content">
          <Row>
            <Col md={7} className="home-header">
              <h1 style={{ paddingBottom: 15 }} className="heading">
                Hi There!{" "}
                <span className="wave" role="img" aria-labelledby="wave">
                  👋🏻
                </span>
              </h1>

              <h1 className="heading-name">
                I'M
                <strong className="main-name"> JENINA ANGELIN</strong>
              </h1>

              <div style={{ padding: 50, textAlign: "left" }}>
                <Type />
              </div>

            </Col>
   
<Col md={5} style={{ paddingBottom: 10 }}>
  <img
    src={finalImage} // Use the imported variable as the source
    alt="Business Analysis"
    className="img-fluid"
    style={{ maxHeight: "500px", paddingTop:"50px" }}
  />
</Col>
          </Row>
        </Container>
      </Container>
      
      {/* Arrow Button */}
      <div className="arrow-button" onClick={handleScrollToBottom}>
      </div>
      <Home2 />
    </section>
  );
}

export default Home;
